import { Component, ElementRef, ViewChild } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { SORT_STATES } from '../../constants/workspace-projects.constants';
@Component({
  selector: 'workspace-project-permission-table-header',
  templateUrl: 'workspace-project-permission-table-header.component.html',
  styleUrl: './workspace-project-permission-table-header.component.scss',
  standalone: false,
})
export class WorkspaceProjectPermissionTableHeader implements IHeaderAngularComp {
  @ViewChild('roleCell', { static: false }) roleCell: ElementRef;
  colId: any;
  params: IHeaderParams;

  searchValue: any;

  order: any = '';

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.colId = params.column.getColId();
  }

  refresh(params: IHeaderParams<any>): boolean {
    return true;
  }

  onSortRequested(event: any) {
    const currentSort = this.params.column.getSort();

    if (currentSort === SORT_STATES.ASC) {
      this.order = SORT_STATES.DESC;
    } else if (currentSort === SORT_STATES.DESC) {
      this.order = SORT_STATES.NONE;
    } else {
      this.order = SORT_STATES.ASC;
    }

    this.params.setSort(this.order || null, event.shiftKey);
  }
}
